'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var jsdom = {
  env: function env(config) {
    if (config.done) {
      config.done(new Error('Only DOM elements are supported in a browser environment'));
    }
  }
};

exports.default = jsdom;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/jsonld-rdfa-parser/dist/browser/jsdom.js
// module id = 268
// module chunks = 0